import { Clipboard } from '@angular/cdk/clipboard';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    inject,
} from '@angular/core';
import {
    UilabMatIconButton,
    UilabMatIconModule,
} from '@uilab/ng-mat-components';
import { Highlight } from 'ngx-highlightjs';

@Component({
    selector: 'avd-css-variable-snippet',
    standalone: true,
    templateUrl: './css-variable-snippet.component.html',
    styleUrls: ['./css-variable-snippet.component.scss'],
    imports: [Highlight, UilabMatIconButton, UilabMatIconModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CssVariableSnippetComponent {
    private readonly clipboard = inject(Clipboard);

    @Input() title: string = '';
    @Input() snippet: string = '';
    @Input() language: string = 'css';

    copySnippet(): void {
        this.clipboard.copy(this.snippet);
    }
}
